<div style="display:flex; flex-direction: column; height: 100%" data-cy="ar-fees-list">

<!--  top buttons-->
  <div style="display: flex; flex-direction: row; padding-top: 8px; padding-bottom: 8px" *ngIf="showTopActionButtons" data-cy="ar-fees-list-top-buttons">
    <button mat-icon-button style="flex-basis: 20px; color: var(--tdo-primary-accent); outline: unset; border: unset; background-color: unset; margin-top: 4px;" (click)="openCreateTransactionItemComponent()" matTooltip="Add procedure" data-cy="ar-fees-list-add-btn">
      <i class="material-icons" data-cy="ar-fees-list-add-icon">add_circle_outline</i>
    </button>
    <button mat-icon-button class="blue-icon" (click)="printFeeCalculation()" matTooltip="Print Fee Calculation" data-cy="ar-fees-list-print-btn">
      <i class="material-icons" data-cy="ar-fees-list-print-icon">print</i>
    </button>
    <button mat-icon-button class="delete-icon" [disabled]="!calcTransactionsSelected()" (click)="removeSelectedItems()" matTooltip="Remove procedure(s)" data-cy="ar-fees-list-delete-btn">
      <i class="material-icons" data-cy="ar-fees-list-delete-icon">delete</i>
    </button>

    <button style="margin-left: 8px; margin-right: 8px;" class="tdo-button primary-accent" [disabled]="!calcTransactionsSelected() || !isValidBenefitsAmount()" (click)="postSelectedTransactions(false, null)" data-cy="ar-fees-list-post-btn">
      Post Selected Transactions
    </button>

    <button class="tdo-button primary-accent" style="margin-left: 8px; margin-right: 8px;" [disabled]="!calcTransactionsSelected()" (click)="this.selectedClaimType = 'pre'; openClaimWizardYN()" data-cy="ar-fees-list-create-claim-btn">
      Create Predetermination Claim
    </button>
    <mat-checkbox style="margin-left: 8px; margin-right: 8px; position: relative; top: 6px;" [(ngModel)]="showPostedTransactions" (click)="updateShowPosted()" data-cy="ar-fees-list-show-posted-checkbox">Show posted transactions</mat-checkbox>

    <mat-form-field data-cy="ar-fees-list-benefits-method">
      <mat-label data-cy="ar-fees-list-benefits-label">Apply benefits</mat-label>
      <mat-select [(ngModel)]="updateFeeMethod" data-cy="ar-fees-list-benefits-select">
        <mat-option data-cy="ar-fees-list-benefits-highest-fee" value="price">
          By Highest Fee
        </mat-option>
        <mat-option data-cy="ar-fees-list-benefits-order" value="order">
          By Order
        </mat-option>
        </mat-select>        
    </mat-form-field>
    <button class="tdo-button primary-accent" style="margin-left: 8px; margin-right: 8px;" (click)="recalculateFeeTable()" data-cy="ar-fees-list-calculate-btn">
      Calculate
    </button>
    <div data-cy="fee-table-labels" class="fee-table-labels">
      <div class="fee-table-benefits-left" [class.negative-amount]="benefitsLeft < 0" data-cy="ar-fees-list-benefits-left">Benefits Left: $ {{ benefitsLeft | currency}} </div>
      <div *ngIf="!ARisEstimating" class="fee-table-benefits-left" [class.negative-amount]="deductibleLeft < 0" data-cy="ar-fees-list-deductible-left">Deductible Left: {{ deductibleLeft | currency}} </div>
      <div *ngIf="ARisEstimating" class="fee-table-benefits-left" [class.negative-amount]="preventativeDeductibleLeft < 0" data-cy="ar-fees-list-preventative-deductible">Deductible Preventative Left: {{ preventativeDeductibleLeft | currency}} </div>
      <div *ngIf="ARisEstimating" class="fee-table-benefits-left" [class.negative-amount]="basicDeductibleLeft < 0" data-cy="ar-fees-list-basic-deductible">Deductible Basic Left: {{ basicDeductibleLeft | currency}} </div>
      <div *ngIf="ARisEstimating" class="fee-table-benefits-left" [class.negative-amount]="otherDeductibleLeft < 0" data-cy="ar-fees-list-other-deductible">Deductible Other Left: {{ otherDeductibleLeft | currency}} </div>
    </div>

  </div>

  <div *ngIf="isTransactionItemsLoading" style="display: flex; flex-direction: row;" data-cy="ar-fees-list-loading">
    <mat-progress-bar style="width: 100%;" mode="indeterminate" data-cy="ar-fees-list-progress-bar"></mat-progress-bar>
  </div>

<!--  new mat table-->
  <div style="display: flex; flex-direction: column; height: 100%; overflow-y: scroll; overflow-x:hidden" data-cy="ar-fees-list-table-container">
    <table mat-table [dataSource]="dataTransactionItems" multiTemplateDataRows data-cy="ar-fees-list-table">

      <ng-container matColumnDef="DiscountID">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 90px;" data-cy="ar-fees-list-header-discount">Adjust</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-discount">
          <div style="display: flex; flex-direction: row; flex-wrap: wrap" class="input-container-height" data-cy="ar-fees-list-discount-container">
            <div data-cy="ar-fees-list-discount-button-1-container">
              <button mat-icon-button
                      [disabled]="isDiscountAvailable(element.ProviderDoctorId, 1) || isTransactionItemsLoading || !element.isDefaultInsurance"
                      [class]="'small-button'"
                      [ngClass]="isDiscountApplied(element.DiscountID, 1) ? 'trans_item_discount_button_selected' : 'trans_item_discount_button'"
                      (click)="applyDiscount(element,1)"
                      [matTooltip]="getDiscountAmountForTooltip(element,1)"
                      data-cy="ar-fees-list-discount-button-1">
                <mat-icon style="font-size: 18px" inline="inline" [matTooltip]="getDiscountAmountForTooltip(element,1)" data-cy="ar-fees-list-discount-icon-1">looks_one</mat-icon>
              </button>
            </div>
            <div data-cy="ar-fees-list-discount-button-2-container">
              <button mat-icon-button
                      [disabled]="isDiscountAvailable(element.ProviderDoctorId, 2) || isTransactionItemsLoading || !element.isDefaultInsurance"
                      [class]="'small-button'"
                      [ngClass]="isDiscountApplied(element.DiscountID, 2) ? 'trans_item_discount_button_selected' : 'trans_item_discount_button'"
                      (click)="applyDiscount(element,2)"
                      [matTooltip]="getDiscountAmountForTooltip(element,2)"
                      data-cy="ar-fees-list-discount-button-2">
                <mat-icon style="font-size: 18px" inline="inline" [matTooltip]="getDiscountAmountForTooltip(element,2)" data-cy="ar-fees-list-discount-icon-2">looks_two</mat-icon>
              </button>
            </div>
            <div data-cy="ar-fees-list-discount-button-3-container">
              <button mat-icon-button
                      [disabled]="isDiscountAvailable(element.ProviderDoctorId, 3) || isTransactionItemsLoading || !element.isDefaultInsurance"
                      [class]="'small-button'"
                      [ngClass]="isDiscountApplied(element.DiscountID, 3) ? 'trans_item_discount_button_selected' : 'trans_item_discount_button'"
                      (click)="applyDiscount(element,3)"
                      [matTooltip]="getDiscountAmountForTooltip(element,3)"
                      data-cy="ar-fees-list-discount-button-3">
                <mat-icon style="font-size: 18px" inline="inline" [matTooltip]="getDiscountAmountForTooltip(element,3)" data-cy="ar-fees-list-discount-icon-3">looks_3</mat-icon>
              </button>
            </div>

          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-discount"></td>
      </ng-container>

      <ng-container matColumnDef="TeethReference">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 95px;" data-cy="ar-fees-list-header-tooth">Tooth</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-tooth">
          <div style="display: flex;" class="input-container-height" data-cy="ar-fees-list-tooth-container">
            <div style="padding-top:3px; flex: 1; text-align: left;text-wrap-mode: nowrap;" data-cy="ar-fees-list-tooth-value">
              {{ element.TeethReference || 'No Tooth Chosen' }}
            </div>
            <div style="text-align: right;" data-cy="ar-fees-list-tooth-edit-container">

              <div style="display: flex;text-wrap-mode: nowrap;" data-cy="ar-fees-list-tooth-edit-row">
                <div style="color:var(--tdo-purple-light) !important; font-size: 16px; cursor: pointer; position: relative; right: 0; color: black; font-weight: 500;"
                     class="input-container-height"
                     (click)="editDetailForTransaction(element, 'DATA_ENABLE_TOOTH_SURFACE_EDIT')"
                     data-cy="ar-fees-list-tooth-edit-btn">
                  <mat-icon *ngIf="element.isMayNeedReferral || element.isNeedsNarrative || (element.isNeedsSurface && !hasToothSurface(element.TeethReference)) || element.isNeedsXray" 
                      inline="true" style="color:orange" [matTooltip]="'Code may require additional information for Claims:' 
                      + (element.isMayNeedReferral ? '\n\r- Referral' : '')
                      + (element.isNeedsNarrative ? '\n\r- Narrative' : '')
                      + (element.isNeedsSurface && !hasToothSurface(element.TeethReference) ? '\n\r- Tooth Surface' : '')
                      + (element.isNeedsXray ? '\n\r- X-ray' : '')"
                      data-cy="ar-fees-list-tooth-warning">warning</mat-icon>
                  <mat-icon inline="true" matTooltip="Edit Tooth Surface" data-cy="ar-fees-list-tooth-edit-icon">edit</mat-icon>
                </div>
              </div>

            </div>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-tooth"></td>
      </ng-container>

      <ng-container matColumnDef="Code">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 85px;" data-cy="ar-fees-list-header-code">Code</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-code">
          <div style="display: flex;" class="input-container-height" data-cy="ar-fees-list-code-container">
            <div style="padding-top:3px; flex: 1; text-align: left" data-cy="ar-fees-list-code-value">
              {{ element.Code || 'No Code Chosen' }}
            </div>
            <div style="text-align: right" data-cy="ar-fees-list-code-edit-container">
              <div style="display: flex;" data-cy="ar-fees-list-code-edit-row">
              <div style="color:var(--tdo-primary-accent) !important; font-size: 16px; cursor: pointer; position: relative; right: 0; color: black; font-weight: 500;"
                   class="input-container-height"
                   (click)="editDetailForTransaction(element, 'DATA_ENABLE_CODE_EDIT')"
                   data-cy="ar-fees-list-code-edit-btn">
                <mat-icon inline="true" matTooltip="Edit Code" data-cy="ar-fees-list-code-edit-icon">edit</mat-icon>
              </div>
              </div>
            </div>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-code"></td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" data-cy="ar-fees-list-header-description">Description</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-description">
          <div style="display: flex" data-cy="ar-fees-list-description-container">
            <div
              style="flex-basis: 100%;
                        padding-top:3px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 100px"
              matTooltip="{{ element.Description || 'No Procedure Chosen' }}"
              data-cy="ar-fees-list-description-value">
              {{ element.Description || 'No Procedure Chosen' }}
            </div>
          </div>
        </td>        
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="1" style="text-align:right" data-cy="ar-fees-list-footer-description">Total: </td>
      </ng-container>

      <ng-container matColumnDef="Price">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 90px;" data-cy="ar-fees-list-header-price">Fee</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-price">
          <div class="input-container-height" data-cy="ar-fees-list-price-container">
            <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-fees-list-price-field">
              <input matInput appCurrencyFormatter class="input-currency"
                     [value]="element.DoctorsPrice"
                     autocomplete="off"
                     (change)="saveTransactionItemUpdateFees($event.target, element, this.PatientId, 7)"
                     data-cy="ar-fees-list-price-input">
            </mat-form-field>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-price">{{getTotalFee() | currency}} </td> 
      </ng-container>
      <ng-container matColumnDef="InsuranceAmount">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 90px;" data-cy="ar-fees-list-header-insurance">Insurance</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-insurance">
          <div class="input-container-height" data-cy="ar-fees-list-insurance-container">
            <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-fees-list-insurance-field">
              <input matInput appCurrencyFormatter class="input-currency"
                     [value]="element.InsuranceAmount"
                     autocomplete="off"
                     (change)="saveTransactionItemUpdateFees($event.target, element, this.PatientId, 5)"
                     data-cy="ar-fees-list-insurance-input">

            </mat-form-field>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-insurance">{{getTotalInsuranceAmount() | currency}} </td> 
      </ng-container>

      <ng-container matColumnDef="DeductibleAmount">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 90px;" data-cy="ar-fees-list-header-deductible">Deductible</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-deductible">
          <div class="input-container-height" data-cy="ar-fees-list-deductible-container">
            <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-fees-list-deductible-field">
              <input matInput appCurrencyFormatter class="input-currency"
                     [value]="element.DeductibleAmount"
                     autocomplete="off"
                     (change)="saveTransactionItemUpdateFees($event.target, element, this.PatientId, 3)"
                     data-cy="ar-fees-list-deductible-input">

            </mat-form-field>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-deductible">{{getTotalDeductible() | currency}} </td> 
      </ng-container>

      <ng-container matColumnDef="PatientResponsibility">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 90px;" data-cy="ar-fees-list-header-patient">Pt Est.</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-patient">
          <div class="input-container-height" data-cy="ar-fees-list-patient-container">
            <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-fees-list-patient-field">
              <input matInput appCurrencyFormatter class="input-currency"
                     [value]="element.PatientResponsibility"
                     autocomplete="off"
                     (change)="saveTransactionItemUpdateFees($event.target, element, this.PatientId, 6)"
                     data-cy="ar-fees-list-patient-input">
            </mat-form-field>
          </div>
        </td>        
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-patient">{{getTotalPatientEstimate() | currency}} </td> 
      </ng-container>

      <ng-container matColumnDef="PresentedDate">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 130px;" data-cy="ar-fees-list-header-presented">Presented<br>Posted</th>
        <td class="matCelly" mat-cell *matCellDef="let element" style="text-align:right" data-cy="ar-fees-list-cell-presented">
          <div class="input-container-height" data-cy="ar-fees-list-presented-container">
            <mat-form-field floatLabel='never' style="width:120px" data-cy="ar-fees-list-presented-field">
              <input matInput placeholder="Presented" [matDatepicker]="presentedDatePicker"
                     (dateChange)="setPostDate(element, $event.value)"
                     [(ngModel)]="element.PresentedDate"
                     (click)="setPresentedDate(element)" autocomplete="off"
                     data-cy="ar-fees-list-presented-input">
              <mat-datepicker-toggle matSuffix [for]="presentedDatePicker" data-cy="ar-fees-list-presented-picker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #presentedDatePicker data-cy="ar-fees-list-presented-picker"></mat-datepicker>
            </mat-form-field>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-presented"></td>
      </ng-container>


      <ng-container matColumnDef="ProviderDoctorId">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 140px;" data-cy="ar-fees-list-header-doctor">Doctor</th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-doctor">
          <div class="input-container-height" data-cy="ar-fees-list-doctor-container">
          <mat-form-field *ngIf="element.isDefaultInsurance" class="insurance-select" floatLabel='never' style="width:115px;" data-cy="ar-fees-list-doctor-field">
            <mat-label data-cy="ar-fees-list-doctor-label">Doctor</mat-label>
            <mat-select [(ngModel)]="element.ProviderDoctorId" (selectionChange)="saveTransactionItemUpdateFees($event, element, this.PatientId, 0)" data-cy="ar-fees-list-doctor-select">
              <mat-option *ngFor="let doctor of element.doctorListDropdown" [value]="doctor.DoctorId" data-cy="ar-fees-list-doctor-option-{{doctor.DoctorId}}">
                {{ this.returnSalutation(doctor.enumSalutationID) + doctor.FirstName + ' ' + doctor.LastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
            <div *ngIf="!element.isDefaultInsurance" data-cy="ar-fees-list-doctor-text">
              {{ returnDoctorNameByID(element.ProviderDoctorId) }}
            </div>
          </div>
         </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-doctor"></td>
      </ng-container>

      <ng-container matColumnDef="DATA_POST">
        <th mat-header-cell *matHeaderCellDef class="matCellyHeader" style="width: 30px;" data-cy="ar-fees-list-header-select">
          <mat-checkbox #allFeesCheck (change)="toggleAllFeesSelected($event)" data-cy="ar-fees-list-select-all"></mat-checkbox>
        </th>
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-select">
          <mat-checkbox [(ngModel)]="element.DATA_POST" (change)="toggleFeeSelected($event)" data-cy="ar-fees-list-select-item"></mat-checkbox>
        </td>
        <td mat-footer-cell *matFooterCellDef data-cy="ar-fees-list-footer-select"></td>
      </ng-container>

      <ng-container matColumnDef="colspan2_empty1">
        <td class="matCelly" mat-cell *matCellDef="let element" [attr.colspan]="1" style="text-align:right" data-cy="ar-fees-list-cell-empty1">Original Fee</td>
      </ng-container>

      <ng-container matColumnDef="colspan2_insurance">
        <td class="matCelly" mat-cell *matCellDef="let element" [attr.colspan]="3" data-cy="ar-fees-list-cell-ins-name">{{ element.PatientInsuranceName }}</td>
      </ng-container>

      <ng-container matColumnDef="OriginalPrice">
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-original">
          <div class="input-container-height" data-cy="ar-fees-list-original-container">
            <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-fees-list-original-field">
              <input matInput appCurrencyFormatter class="input-currency"
                     [value]="element.Price"
                     autocomplete="off"
                     (change)="saveTransactionItemUpdateFees($event.target, element, this.PatientId, 2)"
                     data-cy="ar-fees-list-original-input">
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="colspan2_nocharge">
        <td class="matCelly" mat-cell *matCellDef="let element" [attr.colspan]="3" style="text-align: right" data-cy="ar-fees-list-cell-nocharge">
          <div style="display: flex" data-cy="ar-fees-list-nocharge-container">
            <div data-cy="ar-fees-list-nocharge-checkbox-container">
              <mat-checkbox class="example-margin"
                            [(ngModel)]="element.isNoCharge"
                            [color]="'primary'"
                            (change)="clearReason(element, $event); saveTransactionItemUpdateFees($event, element, this.PatientId, 9)"
                            data-cy="ar-fees-list-nocharge-checkbox">
                No Charge
              </mat-checkbox>
            </div>
            <div style="padding-left: 10px" class="input-container-height" data-cy="ar-fees-list-nocharge-reason-container">
              <mat-form-field *ngIf="this.enumNoChargeReasons" style="width:150px; margin-right:0px !important;" floatLabel='never' data-cy="ar-fees-list-nocharge-reason-field">
                <mat-label data-cy="ar-fees-list-nocharge-reason-label">Reason</mat-label>
                <mat-select [(value)]="element.enumARNoChargeReasonID" (selectionChange)="saveTransactionItem(element)" data-cy="ar-fees-list-nocharge-reason-select">
                  <mat-option *ngFor="let reason of this.enumNoChargeReasons" [value]="reason.ValidValueItemId" data-cy="ar-fees-list-nocharge-reason-option-{{reason.ValidValueItemId}}">
                    {{ reason.ItemDisplayValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="PostedDate">
        <td class="matCelly" mat-cell *matCellDef="let element" style="text-align:right" data-cy="ar-fees-list-cell-posted">
          <div class="input-container-height" data-cy="ar-fees-list-posted-container">
            <mat-form-field floatLabel='never' style="width:120px" data-cy="ar-fees-list-posted-field">
              <input matInput placeholder="Posted" [matDatepicker]="postedDatePicker"
                     (dateChange)="setPostDate(element, $event.value)"
                     [(ngModel)]="element.PostDate"
                     (click)="setPostDate(element)" autocomplete="off"
                     data-cy="ar-fees-list-posted-input">
              <mat-datepicker-toggle matSuffix [for]="postedDatePicker" data-cy="ar-fees-list-posted-picker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #postedDatePicker data-cy="ar-fees-list-posted-picker"></mat-datepicker>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Location">
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-location">
          <div class="input-container-height" data-cy="ar-fees-list-location-container">
            <mat-form-field class="insurance-select" floatLabel='never' style="width:115px" data-cy="ar-fees-list-location-field">
              <mat-label data-cy="ar-fees-list-location-label">Location</mat-label>
              <mat-select [(ngModel)]="element.LOCID" (selectionChange)="saveTransactionItemUpdateFees($event, element, this.PatientId, 8)" data-cy="ar-fees-list-location-select">
                <mat-option *ngFor="let location of this.locations" [value]="location.LOCID" data-cy="ar-fees-list-location-option-{{location.LOCID}}">
                  {{ location.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="end_row_empty">
        <td class="matCelly" mat-cell *matCellDef="let element" data-cy="ar-fees-list-cell-end">
          <button *ngIf="element.DATA_POST" mat-icon-button class="delete-item" (click)="removeItem(element)" matTooltip="Remove procedure" data-cy="ar-fees-list-remove-item-btn">
            <i class="material-icons" data-cy="ar-fees-list-remove-item-icon">delete</i>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row class="top-header-row" *matHeaderRowDef="columnsToDisplayTopRow; sticky: true" data-cy="ar-fees-list-header-row"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayTopRow;" class="first-row-in-group"
          [ngClass]="{'highlight-row': hoverTransactionItemID === element.ARTransactionItemID}"
          (click)="onRowSelected(element)"
          data-cy="ar-fees-list-top-row"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayBottomRow;"
          [ngClass]="{'highlight-row': hoverTransactionItemID === element.ARTransactionItemID}"
          (click)="onRowSelected(element)"
          data-cy="ar-fees-list-bottom-row"></tr>          
      <tr mat-footer-row class="footer-row" *matFooterRowDef="columnsToDisplayTopRow; sticky: true" data-cy="ar-fees-list-footer-row"></tr>
    </table>
  </div>

</div>


